import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgkc032aRequest, Sgkc032aResponse, SGKC032AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * ガス確定使用量再取込取消指示API使用サービス
 * @export
 * @class UsedSgkc032aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc032aService {
    
    /**
     * コンストラクタ
     * @param {SGKC032AService} sGKC032AService
     * @param {ApiCommonService} apiCommonService
     * @param {TimeApiService} timeApiService
     * @param {FeaturesLibConfig} featuresLibConfig
     * @memberof UsedSgkc032aService
     */
    constructor(private sGKC032AService: SGKC032AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * ガス確定使用量再取込取消指示API呼び出し
     * @param {Sgkc032aRequest} request
     * @return {Observable<Sgkc032aResponse>}
     * @memberof UsedSgkc032aService
     */
    cancelGasUsageReimport(request: Sgkc032aRequest): Observable<Sgkc032aResponse> {

        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

        return this.sGKC032AService.kC10WSGKC032APost(<Sgkc032aRequest>this.apiCommonService.setRequestCommon(request), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC032A');
                    return throwError(err.message);
                })
            );
    }

}
